export default async function encodeURL(input) {
  return encodeURIComponent(input)
}
